module.exports = __webpack_public_path__ + "img/guide2.8210f037.png";